import { publicEnv } from './env';

const API_BASE = publicEnv.apiBaseUrl.replace(/\/$/, '');

export function apiUrl(path: string): string {
  if (!/^\/[a-z0-9]/i.test(path) && !/^[a-z0-9]/i.test(path)) {
    throw new Error(`apiUrl: invalid path "${path}"`);
  }
  if (path.includes('//') || path.includes('\\') || path.includes(':')) {
    throw new Error(`apiUrl: invalid path "${path}"`);
  }
  const normalised = path.startsWith('/') ? path : `/${path}`;
  return `${API_BASE}${normalised}`;
}
